import { InputSummaryItem } from '../../../../input-summary';
import { UnitValue } from '../../../../data-structures/unit-value.model';
import InputSummaryUtils from '../../../../../helper/input-summary/input-summary-util';

export interface FeedstockBmpCurveItemInterface {
  bmp: UnitValue;
  hrt: UnitValue;
}

export class FeedstockBmpCurveItem {
  bmp: UnitValue;
  hrt: UnitValue;

  constructor(param: FeedstockBmpCurveItemInterface = {
    bmp: new UnitValue(),
    hrt: new UnitValue(),
  }) {
    if (param) {
      this.bmp = new UnitValue(param.bmp);
      this.hrt = new UnitValue(param.hrt);
    }
  }
}

export interface FeedstockBmpCurveInterface {
  ch4Concentration: UnitValue;
  bmp: string;
  hrt: string;
  curve: FeedstockBmpCurveItem[];
}

export class FeedstockBmpCurve {
  ch4Concentration: UnitValue;
  bmp: string;
  hrt: string;
  curve: FeedstockBmpCurveItem[];

  constructor(param: FeedstockBmpCurveInterface = {
    ch4Concentration: new UnitValue(),
    bmp: null,
    hrt: null,
    curve: [],
  }) {
    if (param) {
      this.ch4Concentration = new UnitValue(param.ch4Concentration);
      this.bmp = param.bmp;
      this.hrt = param.hrt;
      this.curve = [];
      for (const item of param.curve) {
        this.curve.push(new FeedstockBmpCurveItem(item));
      }
    }
  }

  static deepCopy(feedstockBmpCurve: FeedstockBmpCurve) {
    let copy: FeedstockBmpCurve;
    if (feedstockBmpCurve) {
      copy = new FeedstockBmpCurve(feedstockBmpCurve);
      return copy;
    }
    throw new Error('unable to perform deep copy of FeedstockBmpCurve');
  }

  getSummaryInputs(path: string[]) {
    const lastIndex = this.curve.length - 1;
    const lastItem = this.curve[lastIndex];

    let inputs: InputSummaryItem[] = [];
    inputs = InputSummaryUtils.performPush(inputs, FeedstockBmpCurvePropName.ch4Concentration, this.ch4Concentration, [...path, 'ch4Concentration']);
    inputs = InputSummaryUtils.performPush(inputs, FeedstockBmpCurvePropName.bmp, lastItem.bmp, [...path, String(lastIndex), 'bmp']);
    inputs = InputSummaryUtils.performPush(inputs, FeedstockBmpCurvePropName.hrt, lastItem.hrt, [...path, String(lastIndex), 'hrt']);
    return inputs;
  }
}

export enum FeedstockBmpCurvePropName {
  ch4Concentration = 'INPUT_SUMMARY.FEEDSTOCK.BMP_POTENTIAL.CH4_CONCENTRATION',
  bmp = 'INPUT_SUMMARY.FEEDSTOCK.BMP_POTENTIAL.BMP_ABBR',
  hrt = 'INPUT_SUMMARY.FEEDSTOCK.BMP_POTENTIAL.PERIOD',
  curve = 'INPUT_SUMMARY.FEEDSTOCK.BMP_POTENTIAL.BMP_CURVE.BMP',
  id_ch4Concentration = 'CH₄ concentration',
  id_bmp = 'BMP',
  id_hrt = 'HRT',
  id_curve = 'BMP curve',
  curve_coefficient = 'INPUT_SUMMARY.FEEDSTOCK.BMP_POTENTIAL.BMP_CURVE.COEFFICIENT',
}
